module.exports = __webpack_public_path__ + "img/9.81eb8d7c.png";